import { useTranslation } from 'react-i18next'
import { useFeatureToggle } from './useFeatureToggle'

/**
 * Hook that wraps useTranslation to automatically resolve arc-specific i18n keys.
 *
 * When the `arc-mosaico-project` feature flag is enabled, it looks for an arc variant
 * of the requested key by prefixing the last segment with `arc_`.
 * Example: `new_teacher_dashboard.groups_title` → `new_teacher_dashboard.arc_groups_title`
 *
 * If the arc variant exists, it is used; otherwise, the original key is returned.
 */
export const useArcTranslation = () => {
  const { t, i18n } = useTranslation()
  const isArc = useFeatureToggle('arc-mosaico-project') as boolean

  const tArc = (key: string, options?: any) => {
    if (isArc) {
      // Dotted keys: key.segment → key.arc_segment
      const arcKey = key.replace(/\.([^.]+)$/, '.arc_$1')
      if (arcKey !== key && i18n.exists(arcKey)) return t(arcKey, options)
      // Flat keys: key → arc_key
      const arcFlatKey = `arc_${key}`
      if (i18n.exists(arcFlatKey)) return t(arcFlatKey, options)
    }
    return t(key, options)
  }

  return { t: tArc, isArc }
}
